export default class TurnState {
  public turnComplete = false

  get turnIncomplete(): boolean {
    return this.turnComplete === false
  }
}
